<template>
  <v-dialog v-model="show" persistent max-width="420px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Nivel del incendio</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <!-- Aviso -->
            <v-row class="pt-2">
              <v-col>
                <v-select
                  :items="nivelesDisponibles" item-text="INCENDIO_NIVEL" v-model="nivel"
                  label="Nivel del incendio" outlined hide-details dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6">
                <vx-date-text-edit
                  v-model="fechaInicio" :min="fechaInicioMin" :max="fechaInicioMax" @focus="setCurrentDate(0)" :disabled="!nivel" label="Fecha de inicio" required not-future outlined dense
                />
              </v-col>

              <v-col sm="6">
                <vx-date-text-edit v-model="fechaFin" :min="fechaFinMin" @focus="setCurrentDate(1)" :disabled="!nivel || !fechaInicio || fechaInicio.length !== mask.length" label="Fecha de fin" not-future outlined dense />
              </v-col>
            </v-row>
            <v-row />
          </v-container>
        </v-form> <!-- Llegada -->
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green" :disabled="!isValid " @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'

export default {
  props: {
    show: Boolean,
    idIncendio: String
  },

  data: () => ({
    nivelesPosibles: ['Nivel 1', 'Nivel 2'],
    nivel: null,
    fechaInicio: null,
    fechaFin: null,
    nivelIncendio: null,

    fechaInicioMin: null,
    fechaInicioMax: null,
    fechaFinMin: null,
    mask: '##/##/#### ##:##'

  }),

  computed: {
    ...mapGetters('incendio', [
      'tiposIncendioNivel', 'getIncendioByID'
    ]),
    incendio () {
      return this.getIncendioByID(this.idIncendio)
    },
    nivelesDisponibles () {
      const nivelActual = this.incendio?.NIVELES?.[0]?.TIPO_INCENDIO_NIVEL?.INCENDIO_NIVEL
      if (!nivelActual) return this.tiposIncendioNivel
      return this.tiposIncendioNivel.filter(tipo => tipo.INCENDIO_NIVEL !== nivelActual)
    },
    isValid () {
      if (!this.nivel || !this.fechaInicio || this.fechaInicio.length !== this.mask.length) {
        return false
      }

      if (this.fechaFin && this.fechaFin.length !== this.mask.length) {
        return false
      }

      if (DateService.toDayjs(this.fechaInicio, FMT.date).format(FMT.date) >= DateService.toDayjs(this.fechaFin, FMT.date).format(FMT.date)) {
        return false
      }

      return true
    }

  },

  watch: {

    show (value) {
      if (value) {
        this.resetData()
      }
    },
    fechaInicio () {
      if (this.fechaInicio && this.fechaInicio.length === this.mask.length) {
        this.getFechaFinMin()
      }
    },
    fechaFin () {
      if (this.fechaFin && this.fechaFin.length === this.mask.length) {
        this.getFechaInicioMax()
      }
    }
  },

  methods: {
    ...mapActions('incendio', { addNivelIncendioAction: 'addNivelIncendio' }),
    resetData () {
      this.nivel = null
      this.fechaInicio = null
      this.fechaFin = null
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    getFechaInicioMin () {
      if (this.incendio && this.nivel) {
        const nivelPrevio = this.incendio.NIVELES?.[0]

        if (nivelPrevio && nivelPrevio.FECHA_FIN) {
          this.fechaInicioMin = DateService.toDayjs(nivelPrevio.FECHA_FIN, FMT.date).format(FMT.date)
        } else if (!nivelPrevio && this.incendio.ESTADOS?.length) {
          this.fechaInicioMin = DateService.toDayjs(this.incendio.ESTADOS[0].FECHA, FMT.date).format(FMT.date)
        } else {
          this.fechaInicioMin = null
        }
      }
    },
    getFechaInicioMax () {
      this.fechaInicioMax = this.fechaFin
        ? DateService
          .toDayjs(this.fechaFin, FMT.date)
          .add(-1, DayjsUnit.Minute)
          .format(FMT.date)
        : null
    },
    getFechaFinMin () {
      this.fechaFinMin = this.fechaInicio
        ? DateService
          .toDayjs(this.fechaInicio, FMT.date)
          .add(1, DayjsUnit.Minute)
          .format(FMT.date)
        : null
    },
    setCurrentDate (pos) {
      const currentDate = DateService.getCurrentDayJs().format(FMT.date)
      if (pos === 0 && (!this.fechaInicio || this.fechaInicio === '')) {
        this.getFechaInicioMin()
        this.getFechaInicioMax()
        this.fechaInicio = currentDate
      } else if (pos === 1 && (!this.fechaFin || this.fechaFin === '')) {
        this.getFechaFinMin()
        this.fechaFin = currentDate
      }
    },
    cancelar () {
      this.resetData()
      this.$emit('cancelar')
    },

    aceptar () {
      let estadoAdd
      for (let i = 0; i < this.tiposIncendioNivel.length; i++) {
        if (this.nivel === this.tiposIncendioNivel[i].INCENDIO_NIVEL) {
          estadoAdd = this.tiposIncendioNivel[i]
          break
        }
      }
      this.nivelIncendio = {
        ID_INCENDIO_NIVEL: this.$uuid.createUUID(),
        ID_INCENDIO: this.incendio.ID_INCENDIO,
        ID_TIPO_INCENDIO_NIVEL: estadoAdd.ID_TIPO_INCENDIO_NIVEL,
        FECHA_INICIO: DateService.toDayjs(this.fechaInicio, FMT.date).toISOString(),
        FECHA_FIN: this.fechaFin ? DateService.toDayjs(this.fechaFin, FMT.date).toISOString() : null,
        TIPO_INCENDIO_NIVEL: estadoAdd
      }
      this.addNivelIncendioAction(this.nivelIncendio)

      this.resetData()
      this.$emit('redrawIncendio')
      this.$emit('aceptar')
    }
  }
}
</script>

<style scoped>

</style>
